import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../enums';
import { beforeEnter } from './../guards';

const Component = () => import('./BusinessUnitUpdate.vue');

export default {
  path: buildChildURL(
    SitesRoutePathNames.SITE,
    SitesRoutePathNames.BUSINESS_UNIT,
    SitesRoutePathNames.BUSINESS_UNIT_ID,
  ),
  name: SitesRouteNames.SITE_BUSINESS_UNIT,
  component: Component,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;
